<mat-card appearance="outlined" [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>
      Results
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="row" *ngIf="quoteData && quoteData.data">
      <!-- max -->
      <div class="row col-sm-4" *ngIf="dialDownEnabled">
          <div class="col-sm-3 text-end d-flex align-items-center justify-content-center">
            Maximum
          </div>
          <div class="row col-sm-9">
            <mat-form-field appearance="outline">
              <mat-label>Total loan amount</mat-label>
              <input matInput placeholder="Total loan amount" type="number" readonly [value]="quoteData['data']['app-quote-details']['totalLoanAmount']">
              <span matPrefix>$&nbsp;</span>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Total monthly repayments</mat-label>
              <input matInput placeholder="Total monthly repayments" type="number" readonly [value]="rateData.MaxTotalMonthlyRepayments">
              <span matPrefix>$&nbsp;</span>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Maximum Rate %</mat-label>
              <input matInput placeholder="Maximum Rate %" type="number" readonly value="{{rateData.FirstmacMaxBorrowingRate * 100 | number:'1.2-2'}}">
              <span matSuffix>%&nbsp;</span>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Maximum Brokerage amount</mat-label>
              <input matInput placeholder="Maximum Brokerage amount" type="number" readonly [value]="rateData.MaxBrokerageAmountAvailable">
              <span matPrefix>$&nbsp;</span>
            </mat-form-field>
          </div>
      </div>
      <!-- adjusted -->
      <div class="row" [ngClass]="{'col-sm-6': !dialDownEnabled, 'col-sm-4': dialDownEnabled}">
        <div class="col-sm-3 text-end d-flex align-items-center justify-content-center">
          <ng-container *ngIf="dialDownEnabled">
            Adjusted
          </ng-container>
        </div>
        <div class="row col-sm-9">
          <mat-form-field appearance="outline">
            <mat-label>Total loan amount</mat-label>
            <input matInput placeholder="Total loan amount" type="number" readonly [value]="quoteData['data']['app-quote-details']['totalLoanAmount']">
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Total monthly repayments</mat-label>
            <input matInput placeholder="Total monthly repayments" type="number" readonly [value]="rateData?.AdjustedTotalMonthlyRepayments">
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Rate to borrower %</mat-label>
            <input matInput placeholder="Rate to borrower %" type="number" readonly value="{{rateData?.TPSRateToBorrower * 100 | number:'1.2-2'}}">
            <span matSuffix>%&nbsp;</span>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Brokerage amount (inc GST)</mat-label>
            <input matInput placeholder="Brokerage amount (inc GST)" type="number" readonly [value]="rateData?.AdjustedBrokerageAmount">
            <span matPrefix>$&nbsp;</span>
          </mat-form-field>
        </div>
      </div>
      <!-- actions -->
      <div class="col-sm-4">
        <div class="row">
          <div class="col-sm-8 offset-sm-2 d-flex flex-column flex-grow">
            <button class="fmc-button-primary" mat-raised-button color="'primary'" type="button" (click)="printPdf()">Print quote</button>
            <br />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-8 offset-sm-2 d-flex flex-column flex-grow">
            <button class="fmc-button-primary" mat-raised-button color="'primary'" type="button" (click)="emailQuote()">Email quote</button><br />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-8 offset-sm-2 d-flex flex-column flex-grow">
            <button class="fmc-button-primary" mat-raised-button color="'primary'" type="button" (click)="redirectWizard()"><strong>Apply now</strong></button><br />
          </div>
        </div>
      </div>
    </div>

    <!-- Expiration -->
    <div class="row">
      <div class="col-sm-12 text-center">
        This quote is valid for the next 30 days and will expire on {{ expirationDate | date: 'longDate' }}.
      </div>
    </div>
  </mat-card-content>
</mat-card>
